import { useEffect, useRef, useState } from 'react';
import { installerApi } from '../../utils/installerApi';
export default function StageAppeal({ token, jobId, stage, onSaved, disabled = false }) {
  const [open, setOpen] = useState(false); const [reason, setReason] = useState(''); const [error, setError] = useState(''); const [busy, setBusy] = useState(false);
  const wasOpen = useRef(false); const dialog = useRef(null); const trigger = useRef(null); const input = useRef(null); const active = useRef(true);
  useEffect(() => { active.current = true; return () => { active.current = false; }; }, []);
  useEffect(() => {
    if (open) { if (dialog.current?.showModal) { dialog.current.removeAttribute('open'); dialog.current.showModal(); } input.current?.focus(); }
    else if (wasOpen.current) trigger.current?.focus();
    wasOpen.current = open;
  }, [open]);
  if (!stage || !['open', 'failed', 'in_review', 'submitted', 'ai_reviewing'].includes(stage.state)) return null;
  if (stage.state === 'in_review' && stage.review_phase === 'human' && !stage.human_review_requested) return null;
  if (stage.human_review_requested) return <p className="inst-lead" role="status">درخواست بررسی انسانی ثبت شده است.</p>;
  const send = async () => {
    if (busy || reason.trim().length < 10) return;
    setBusy(true); setError('');
    try {
      await installerApi.appealStage(token, jobId, stage.id, { reason: reason.trim(), attempt_id: stage.state === 'open' ? null : stage.current_attempt_id || null });
      if (active.current) { await onSaved?.(); if (active.current) setOpen(false); }
    } catch (e) { if (active.current) setError(e.message); }
    finally { if (active.current) setBusy(false); }
  };
  const close = () => { if (!busy) setOpen(false); };
  return <>
    <button ref={trigger} type="button" className="inst-btn inst-btn-ghost" disabled={disabled || busy} onClick={() => setOpen(true)}>بررسی ناظر به‌جای هوش مصنوعی</button>
    {open && <dialog open ref={dialog} className="inst-appeal-dialog" aria-modal="true" aria-labelledby="appeal-title" onCancel={(e) => { e.preventDefault(); close(); }}
      onKeyDown={(e) => { if (e.key === 'Escape') { e.preventDefault(); close(); } if (e.key === 'Tab') {
        const controls = [...dialog.current.querySelectorAll('textarea,button')].filter((c) => !c.disabled);
        if (e.shiftKey && document.activeElement === controls[0]) { e.preventDefault(); controls.at(-1)?.focus(); }
        else if (!e.shiftKey && document.activeElement === controls.at(-1)) { e.preventDefault(); controls[0]?.focus(); }
      } }}>
      <h2 id="appeal-title">درخواست بررسی انسانی</h2><p>دلیل را بنویسید. مدارک عکس و پیش‌نیازها همچنان الزامی است.</p>
      <label className="inst-label">دلیل درخواست<textarea ref={input} className="inst-input" value={reason} disabled={busy} maxLength={2000} onChange={(e) => setReason(e.target.value)} /></label>
      {error && <p className="inst-alert" role="alert">{error}</p>}
      <button type="button" className="inst-btn" disabled={busy || reason.trim().length < 10} onClick={send}>ثبت درخواست</button>
      <button type="button" className="inst-btn inst-btn-ghost" disabled={busy} onClick={close}>انصراف</button>
    </dialog>}
  </>;
}
